


import React, { Component, setStateת ,Fragment} from 'react';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import { Button, FormControl, Form, ListGroup, InputGroup, Image, Badge, h5 ,Dropdown} from 'react-bootstrap';
import Alert from './Alert'
import DeleteSharpIcon from '@material-ui/icons/DeleteSharp';
import Exam_List from './Exam_List'
import Loader from 'react-loader-spinner'
import Footer from './Footer'
import Syllabus_list from './Syllabus_List'
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { exportComponentAsJPEG, exportComponentAsPDF, exportComponentAsPNG } from 'react-component-export-image';
import ReactGA from 'react-ga'
import FilterBy from './FilterBy'
import { Typeahead,AsyncTypeahead } from 'react-bootstrap-typeahead'; // ES2015
const _ = require('lodash');
const axios = require('axios');
const Ga = require('../Logic/Ga')
const moment = require('moment');

const animatedComponents = makeAnimated();
class Schedule extends Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
    this.state = {
      value: '',
      courses: [],
      courses_Name: [],
      cuurse_to_find: [],
      show: false,
      loadBar: false,
      msgAlert: '',
      scheduleToShow: 0,
      scheduleResults: 0,
      last_response: '',
      Current_Algorithm: 'Less days',
      Count_build: '',
      Course_Total_point: 0,
      Course_Exams: [],
      Alert_Same_Day_Exam: 0,
      Course_Syllabus: [],
      Select_Lecturer: [],
      Select_Lecturer_curent: [],
      Show_Select_Lecturer: [],
      last_response_server: '',
      isLoading:false,
      options:[],
      semester:'א'

    };


    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.LoadBar = this.LoadBar.bind(this);
    this.onChangeLecturer = this.onChangeLecturer.bind(this);
  }

  selectSemster(semster){
    if(semster!=this.state.semester)
    this.setState( {
      value: '',
      courses: [],
      courses_Name: [],
      cuurse_to_find: [],
      show: false,
      loadBar: false,
      msgAlert: '',
      scheduleToShow: 0,
      scheduleResults: 0,
      last_response: '',
      Current_Algorithm: 'Less days',
      Count_build: '',
      Course_Total_point: 0,
      Course_Exams: [],
      Alert_Same_Day_Exam: 0,
      Course_Syllabus: [],
      Select_Lecturer: [],
      Select_Lecturer_curent: [],
      Show_Select_Lecturer: [],
      last_response_server: '',
      isLoading:false,
      options:[],
      semester:semster,

    });


  }
  componentDidMount() {
    
    const list = { ...this.state }
    axios.get(process.env.REACT_APP_SERVER+'count_build')
      .then((response) => {


        list.Count_build = response.data;
        this.setState(list);

      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
  }
   handleSearch = (query) => {

    let state = { ...this.state }
    
    state.isLoading = true
    state.value=query;
    this.setState(state);

    var axios = require('axios');
    var qs = require('qs');
    var data = qs.stringify({
      'semster':this.state.semester,
     'name': query
    });
    var config = {
      method: 'post',
      url: process.env.REACT_APP_SERVER+'searchcodebyname',
      headers: { 
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data : data
    };

    axios(config)
    .then((resp) => {
     
        return resp.data;
    })

    .then(( items ) => {
      const options = items.map((i) => ({
        name: i.name,
        code: i.code,
  
      }));

     
      let state = { ...this.state }
      state.isLoading = false
      state.options=options;
  

      this.setState(state);
  
    }).catch(()=>{
      let state = { ...this.state }
      state.isLoading = false
      this.setState(state);
    });
  };




handleChangeSemster(event){
  const state = { ...this.state }
  this.setState(state);


}


  handleChange(event) {

if(event!=null  &&event.length>0){
    const state = { ...this.state }
    state.value = event[0].code
    state.isLoading=false;
    state.loadBar=true;
    this.AddCourse( state.value );
    this.setState(state);
  }
  else
  {
    console.log(event)
    const state = { ...this.state }
    state.value = event
    state.isLoading=false;
 
    this.setState(state);
  }
  }

  handleSubmit(event) {
    alert('A name was submitted: ' + this.state.value);
    event.preventDefault();
  }
  LoadBar(state) {
    const list = { ...this.state };
    list.loadBar = state;
    this.setState(list);
  }

  schedule_move(num) {
    const list = { ...this.state };
    if (list.scheduleToShow + num >= 0 && list.scheduleToShow + num < list.scheduleResults) {
      list.scheduleToShow = list.scheduleToShow + num
      list.courses = Ga.GetHtmlTabale(list.last_response[list.scheduleToShow])

      this.setState(list);
    }
  }

  Change_Current_Algorithm(name) {

    const list = { ...this.state };
    list.Current_Algorithm = name;
    this.setState(list)

  }

  onChangeLecturer(e, i, type) {

    const list = { ...this.state };
    if (e != null && e.length > 0)
      switch (type) {
        case 'lec':
          list.Select_Lecturer_curent[i].lecture = e;
          break;
        case 'exe':
          list.Select_Lecturer_curent[i].exercise = e;
          break;

        case 'lab':
          list.Select_Lecturer_curent[i].lab = e;
          break;

      }
    this.setState(list);
  }


  clone(obj) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
  }
  Prosses_build = async (response) => {
    try {


      await response.data.courses.forEach(async (course, k) => {
        var newarr = [];

        await course.lecture.forEach(async (lecture, z) => {
          var flag = 0;
          await this.state.Select_Lecturer_curent[k].lecture.forEach((value) => {
            if (lecture.Lecturer[0].normalize() === value.value.normalize() && flag == 0) {
              flag = 1;
              newarr.push(course.lecture[z]);
            }

          })
        }
        );
        course.lecture = newarr;
      });

      await response.data.courses.forEach(async (course, k) => {
        var newarr = [];
        var flag = 0;
        await course.exercise.forEach(async (exercise, z) => {
          var flag = 0;
          await this.state.Select_Lecturer_curent[k].exercise.forEach((value) => {
            if (exercise.Lecturer[0].normalize() === value.value.normalize() && flag == 0) {
              flag = 1;
              newarr.push(course.exercise[z]);
            }

          })
        }
        );
        course.exercise = newarr;
      });

      await response.data.courses.forEach(async (course, k) => {
        var newarr = [];

        await course.lab.forEach(async (lab, z) => {
          var flag = 0;
          await this.state.Select_Lecturer_curent[k].lab.forEach((value) => {
            if (lab.Lecturer[0].normalize() === value.value.normalize() && flag == 0) {
              flag = 1;
              newarr.push(course.lab[z]);
            }

          })
        }
        );
        course.lab = newarr;
      });

      Ga.courses = response.data;
      const list = { ...this.state }

      response.data.courses.forEach(value => {
        list.Show_Select_Lecturer.push(false)
      })
      list.Course_Total_point = 0;
      list.Course_Exams = []
      list.Course_Syllabus = []
      list.Alert_Same_Day_Exam = 0;
      response.data.courses.forEach(element => {
        if (element.course_point !== NaN && element.course_point !== null && element.course_point !== undefined && element.course_point !== '') {

          list.Course_Total_point += parseFloat(element.course_point)
        }
        if (element.course_exam_at !== NaN && element.course_exam_a !== null && element.course_exam_a !== undefined && element.course_exam_a !== '' && element.course_exam_a.length > 7) {
          list.Course_Exams.push({
            coursename: element.course_name + " מועד א' ",
            Exam_Date: moment(element.course_exam_a, "DD/MM/YYYY")
          })
          list.Course_Exams.push({
            coursename: element.course_name + " מועד ב' ",
            Exam_Date: moment(element.course_exam_b, "DD/MM/YYYY")
          })


          list.Course_Exams.sort(function custom_sort(a, b) {
            if (a.Exam_Date - b.Exam_Date === 0)
              list.Alert_Same_Day_Exam = 1;
            return a.Exam_Date - b.Exam_Date
          });

        }

        if (element.link_syllabus !== NaN && element.link_syllabus !== null && element.link_syllabus !== undefined && element.link_syllabus !== '') {
          list.Course_Syllabus.push({
            coursename: element.course_name,
            Syllabus_link: element.link_syllabus
          })


        }





      });


      switch (this.state.Current_Algorithm) {
        case "Less days":
          list.last_response = Ga.InitGa(response.data, Ga.fitnessFunctionEmptyDays);
          break;
        case "Less empty hours":
          list.last_response = Ga.InitGa(response.data, Ga.fitnessFunctionEmptyHour);
          break;

      }



      list.scheduleResults = list.last_response.length

      list.courses = await Ga.GetHtmlTabale(list.last_response[0])
      list.loadBar = false;
      list.scheduleToShow = 0

      this.setState(list);
    }
    catch {
      const list = { ...this.state }
      list.courses = []

      list.show = true;
      list.loadBar = false;
      list.scheduleResults = 0
      list.msg = "קיים סיכוי גבוה שיש התנגשות בין הקורסים שבחרת, אנא נסה להוריד קורס ולנסות שוב"
      list.last_response = null
      this.setState(list);
    }
  }

  Build_schedule = async (Array) => {

    ReactGA.event({
      category: "Build new schedule",
      action: Array
    })




    const list = await { ...this.state };

    list.loadBar = true;
    this.setState(list, async () => {
      if (Array.length != 0) {

        list.scheduleResults = 0;
        list.courses = [];

        list.scheduleToShow = 0;
        if (list.last_response_server === '') {
          var data = JSON.stringify({'semster':this.state.semester, "courses": Array });
          var config = {
            method: 'post',
            url: process.env.REACT_APP_SERVER+'test',
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          };
          axios(config)
            .then(async (response) => {

              list.last_response_server = _.cloneDeep(response);
              this.setState(list);



              this.Prosses_build(_.cloneDeep(response))

            })
            .catch(function (error) {

              console.log(error);
            });

        }
        else {
          setTimeout(() => {

            this.Prosses_build(_.cloneDeep(list.last_response_server));
          }, 300);

        }

      }

      else {
        list.loadBar = false
        list.show = true;
        list.msg = "אנא בחר לפחות קורס אחד"
        this.setState(list)
      }
    })




  }


  AddCourse = (num_Course) => {

    const list = { ...this.state };
    if (num_Course != '') {

      this.LoadBar(true);
      const list = { ...this.state };


      var data = JSON.stringify({ 
        'semster':this.state.semester,
        "courses": [num_Course] });
      var config = {
        method: 'post',
        url: process.env.REACT_APP_SERVER+'coursename2',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      axios(config)
        .then((response) => {
          if (response.data === false)
            list.show = true;
          else {
            list.last_response = '';
            if (list.cuurse_to_find.indexOf(num_Course) === -1) {
              list.show = false;
              ReactGA.event({
                category: "Add course",
                action: response.data.courses[0].course_name,
                label: num_Course
              })


              list.cuurse_to_find.push(num_Course);
              list.courses_Name.push(response.data.courses[0].course_name)
              var arr1 = []
              for (var i = 0; i < response.data.courses[0].lecture.length; i++) {
                arr1.push({
                  value: response.data.courses[0].lecture[i],
                  label: response.data.courses[0].lecture[i],

                });
              }
              var arr2 = []
              for (var i = 0; i < response.data.courses[0].exercise.length; i++) {
                arr2.push({
                  value: response.data.courses[0].exercise[i],
                  label: response.data.courses[0].exercise[i],

                });
              }
              var arr3 = []
              for (var i = 0; i < response.data.courses[0].lab.length; i++) {
                arr3.push({
                  value: response.data.courses[0].lab[i],
                  label: response.data.courses[0].lab[i],

                });
              }
              list.Select_Lecturer.push({
                lecture: arr1,
                exercise: arr2,
                lab: arr3
              })

              list.Select_Lecturer_curent.push({
                lecture: arr1,
                exercise: arr2,
                lab: arr3
              })

            }
            list.last_response_server = '';
          }
          list.msg = "אנא הקש קוד קורס קיים"

          this.setState(list);
        })
        .catch(function (error) {
          list.msg = "אנא הקש קוד קורס קיים"
          this.setState(list);
        });
    }
    else {
      list.show = true;
      list.msg = "אנא הקש קוד קורס קיים"
      this.setState(list)
    }
  }

  DeleteCourse = (num_Course) => {
    const list = { ...this.state };

    const position = list.courses_Name.indexOf(num_Course);
    if (~position) {
      list.Course_Exams = []
      list.Course_Syllabus = []
      list.last_response_server = '';
      list.Alert_Same_Day_Exam = 0;
      list.courses_Name.splice(position, 1)
      list.cuurse_to_find.splice(position, 1);
      list.Select_Lecturer.splice(position, 1)
      list.Show_Select_Lecturer.splice(position, 1)
      list.Select_Lecturer_curent.splice(position, 1)

    };
    list.scheduleResults = 0;
    list.courses = [];
    list.show = false;
    list.last_response = ''
    this.setState(list);
  }


  Show_Lecturer = (i) => {
    const list = { ...this.state };
    list.Show_Select_Lecturer[i] = !list.Show_Select_Lecturer[i]
    this.setState(list);
  }
  render() {
    return (

      <div className="input">
        <Image src={require('../img/logoBraude.png').default} fluid />
        <a href="./">

        </a>
        <h1>
          <Badge variant="light">בונה מערכת אוטומטי</Badge>
        </h1>

        <Alert state={this.state.show} msg={this.state.msg}></Alert>
        <InputGroup className="mb-3">
          
          {/* <Button variant="dark" onClick={() => this.AddCourse(this.state.value)}>הוסף קורס ➕</Button> */}
          <Dropdown >
  <Dropdown.Toggle  id="dropdown-basic">
  סמסטר {this.state.semester}
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item onClick={()=>{
      this.selectSemster('א');

    }}>א</Dropdown.Item>
    <Dropdown.Item onClick={()=>{
       this.selectSemster('ב');

    }}>ב</Dropdown.Item>
    <Dropdown.Item  onClick={()=>{
      const state = { ...this.state }
      this.selectSemster('ג');

    }}>ג</Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
          <AsyncTypeahead
 onChange={this.handleChange}
 filterBy={() => true}
 id="async-example"
 isLoading={this.state.isLoading}
 labelKey="code"

 minLength={1}
 onSearch={this.handleSearch}
 options={this.state.options}
 placeholder="נא הקש קוד קורס או שם קורס"

 renderMenuItemChildren={(option, props) => (
   <Fragment>
   <span>{option.name}</span>
     <span> {option.code}</span>
   </Fragment>
 )}
 
/>
     
          <Button variant="success" onClick={() => this.Build_schedule(this.state.cuurse_to_find)} >בנה מערכת🔨 </Button>
        </InputGroup>
        
        <Form.Check type="checkbox" label="פחות ימים" name="formHorizontalRadios" type="radio" onClick={() => this.Change_Current_Algorithm("Less days")} defaultChecked />
        <Form.Check type="checkbox" label="פחות חלונות" name="formHorizontalRadios" type="radio" onClick={() => this.Change_Current_Algorithm("Less empty hours")} />

        <Loader
          type="Puff"
          color="#00BFFF"
          visible={this.state.loadBar} //3 secs
        />
        <div variant="primary" class={this.state.loadBar === true ? "visible" : 'invisible'} ><Badge > אנא המתן התהליך לוקח מספר רגעים</Badge></div>
        <ListGroup>
          {this.state.courses_Name.map((item, i) => (
            <ListGroup.Item variant={i % 2 == 0 ? 'dark' : ''}><h5>
              <a title="מידע נוסף" href={"https://info.braude.ac.il/yedion/fireflyweb.aspx?PRGNAME=S_LOOK_FOR_NOSE&ARGUMENTS=SubjectCode&SubjectCode="+this.state.cuurse_to_find[this.state.courses_Name.indexOf(item)]} target="_blank">ℹ️</a>{item} {this.state.cuurse_to_find[this.state.courses_Name.indexOf(item)]}    <DeleteSharpIcon onClick={() => this.DeleteCourse(item)} /></h5>
              <br />
              <Button variant="dark" onClick={() => { this.Show_Lecturer(i) }} size="sm">
                עריכת מרצים👨‍🏫
      </Button>



              {this.state.Show_Select_Lecturer[i] ? <div   >
                {this.state.Select_Lecturer[i].lecture.length > 0 ?
                  <div>הרצאה<Select
                    onChange={(event) => this.onChangeLecturer(event, i, 'lec')}

                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    defaultValue={this.state.Select_Lecturer_curent[i].lecture}
                    isMulti
                    options={this.state.Select_Lecturer[i].lecture}
                    value={this.state.Select_Lecturer_curent[i].lecture}
                    isClearable={false}
                  /> </div> : ''}
                {
                  this.state.Select_Lecturer[i].exercise.length ?
                    <div>תרגול < Select
                      isClearable={false}
                      onChange={(event) => this.onChangeLecturer(event, i, 'exe')}
                      isHidden
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      defaultValue={this.state.Select_Lecturer_curent[i].exercise}
                      isMulti

                      options={this.state.Select_Lecturer[i].exercise}
                      value={this.state.Select_Lecturer_curent[i].exercise}
                    /></div> : ''
                }
                {
                  this.state.Select_Lecturer[i].lab.length > 0 ?
                    <div>מעבדה
                <Select
                        onChange={(event) => this.onChangeLecturer(event, i, 'lab')}
                        placeholder="מעבדה"
                        isClearable={false}
                        isHidden
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        defaultValue={this.state.Select_Lecturer_curent[i].lab}
                        isMulti
                        options={this.state.Select_Lecturer[i].lab}
                        value={this.state.Select_Lecturer_curent[i].lab}
                      /></div> : ''


                }
              </div> : ''}
            </ListGroup.Item>
          ))}
        </ListGroup>

        <div value="asfsa" class={this.state.last_response === null ? "visible" : 'invisible'}> <Badge variant="danger">לא נמצאו תוצאות</Badge></div>


        <div value="asfsa" class={this.state.scheduleResults > 0 ? "visible" : 'invisible'}>{(<h4><Badge variant="light">🎉יש הצלחנו למצוא תוצאות</Badge></h4>)}</div>
        <div value="asfsa" class={this.state.scheduleResults > 0 ? "visible" : 'invisible'}>{(<h4><Badge variant="success">אפשריות שנמצאו:{this.state.scheduleResults}</Badge></h4>)}
          <br />

          <Button variant="dark" onClick={() => this.schedule_move(-1)}>👈קודם</Button>
          <Button variant="dark" onClick={() => this.schedule_move(+1)}>הבא👉</Button>
          <br />



          <ListGroup>
            <ListGroup.Item >סך הכל נ"ז:{this.state.Course_Total_point}</ListGroup.Item>
            <h6> <Badge variant="light"> תוצאה מספר:{this.state.scheduleToShow + 1}</Badge></h6>
          </ListGroup>
          <React.Fragment>
     
            <Button onClick={() => exportComponentAsJPEG(this.componentRef, {fileName:"מערכת שעות"})}>
         שמור כתמונה
       </Button>
     </React.Fragment>
          <div ref={this.componentRef}>
            {
              ReactHtmlParser(this.state.courses)
            }

          </div>
          <Exam_List Course_Exams={this.state.Course_Exams} count={this.state.Alert_Same_Day_Exam}></Exam_List>
          <br />
          <br />
          <Syllabus_list Course_Syllabus={this.state.Course_Syllabus} />
        </div>


        <Footer countBuild={this.state.Count_build}></Footer>
      </div>

    )
  }
}

export default Schedule;